const VALIDATION_OPTIONS = {
    strict: true,
    stripUnknown: false,
    abortEarly: false
}

export default VALIDATION_OPTIONS